const en = {
  "day.view": "Day View",
  "week.view": "Week View",
  "month.view": "Month View",
  previous_month: "Previous Month",
  next_month: "Next Month",
  previous_week: "Previous Week",
  next_week: "Next Week",
  previous_day: "Previous Day",
  next_day: "Next Day",
  schedule_appointment: "Schedule Appointment",
  upcoming_meetings: "Upcoming Events",
  "menu.appointment_scheduling": "Appointment Scheduling",
  "appointment_scheduling.scheduled_services.product": "Services",
  "appointment_scheduling.scheduled_services": "Services",
  "appointment_scheduling.scheduled_services.unit_price": "Price",
  "appointment_scheduling.customer": "Client",
  "appointment_scheduling.patient": "Patient",
  "appointment_scheduling.consumer": "Contact",
  "appointment_scheduling.overbooking": "Overbooking",
  "appointment_scheduling.non_billable": "Non Billable",
  "appointment_scheduling.number": "Number",
  "appointment_scheduling.start_date": "Start Time",
  "appointment_scheduling.end_date": "End Time",
  "appointment_scheduling.availability": "Availability",
  "appointment_scheduling.locking": "Locking",
  "appointment_scheduling.appointment_date": "Date",
  "appointment_scheduling.professional": "Professional",
  "appointment_scheduling.product": "Product",
  "appointment_scheduling.comment": "Comment",
  "appointment_scheduling.show_up": "Showed Up",
  "appointment_scheduling.show_up_message":
    "Appointment marked as attended successfully",
  "appointment_scheduling.no_show_up": "No Show",
  "appointment_scheduling.no_show_up_message": "Appointment marked as no-show",
  "appointment_scheduling.schedule": "Schedule",
  "appointment_scheduling.schedule_message":
    "Appointment scheduled successfully",
  "appointment_scheduling.add_new": "Add Appointment",
  "appointment_scheduling.attended": "Attended",
  "appointment_scheduling.attended_message":
    "Appointment attended successfully",
  "appointment_scheduling.cancel": "Cancelled",
  "appointment_scheduling.cancelled": "Cancelled",
  "appointment_scheduling.scheduled": "Scheduled",
  "appointment_scheduling.messge_error": "Error scheduling appointment",
  "appointment_scheduling.draft": "Draft",
  "appointment_scheduling.pending_sessions": "Pending Sessions",
  appointment_scheduling: "Appointment Scheduling",
  "appointment_scheduling.sale": "Sale",
  "appointment_scheduling.services": "Services",
  "appointment_scheduling.state": "State",
  "appointment_scheduling.page.appointment": "APPOINTMENT",
  "appointment_scheduling.page.services": "SERVICES",
  "appointment_scheduling.page.payments": "PAYMENTS",
  "appointment_scheduling.page.history": "HISTORY",
  "appointment_scheduling.page.appointment_calendar": "APPOINTMENT CALENDAR",
  "account.statement.line.description": "Description",
  "account.statement.line.sale": "Sale",
  "account.statement.statement": "Payment Method",
  "account.statement.amount": "Amount to Pay",
  "account.statement.voucher": "Voucher",
  "account.statement.pay": "Pay",
  "sale.line.origin.appointment_date": "Delivery Date",
  "sale.sale.bill": "Invoice",
  "sale.sale.send_email": "Send Email",
  "appointment_scheduling.calendar": "AVAILABLE CALENDAR",
  "appointment_scheduling.calendar.start_date": "Start Date",
  "appointment_scheduling.calendar.end_date": "End Date",
  "appointment_scheduling.calendar.recurrence": "Recurrence",
  "appointment_scheduling.calendar.type": "Type",
  "appointment_scheduling.calendar.professional": "Professional",
  "appointment_scheduling.calendar.weekdays": "Day of Week",
  "appointment_scheduling.calendar.recurrence_end_date": "Recurrence End Date",
  "appointment_scheduling.calendar.state": "State",
  "appointment_scheduling.calendar.notes": "Notes",
  "appointment_scheduling.calendar.Locking": "Locking",
  "appointment_scheduling.calendar.Availability": "Availability",
  "appointment_scheduling.calendar.Does not repeat": "Does Not Repeat",
  "appointment_scheduling.calendar.Daily": "Daily",
  "appointment_scheduling.calendar.Weekly": "Weekly",
  "appointment_scheduling.calendar.Monthly": "Monthly",
  "appointment_scheduling.calendar.Custom": "Custom",
  "appointment_scheduling.calendar.all_day": "All Day",
  "appointment_scheduling.calendar.Monday": "Monday",
  "appointment_scheduling.calendar.Tuesday": "Tuesday",
  "appointment_scheduling.calendar.Wednesday": "Wednesday",
  "appointment_scheduling.calendar.Thursday": "Thursday",
  "appointment_scheduling.calendar.Friday": "Friday",
  "appointment_scheduling.calendar.Saturday": "Saturday",
  "appointment_scheduling.calendar.Sunday": "Sunday",
  "appointment_scheduling.calendar.schedule": "Schedule",
  "account.statement.line.statement.state": "State",
  "party.consumer": "Contact",
  "party.consumer.id_number": "Id Number",
  "party.consumer.name": "Name",
  "party.consumer.phone": "Phone",
  "party.consumer.address": "Address",
  "party.consumer.notes": "Notes",
  "sale.line.sale.sale_date": "Sale Date",
  "sale.line.sale": "Sale",
  "statement.line.print_voucher": "Print Voucher",
  dont_delete_payment_line:
    "You cannot remove a payment from a statement in validated or closed status.",
  sheduled: "Scheduled",
  "account.statement.other_income": "Other Income",
  "button.sales": "Sales",
  "button.appointments": "Appointments",
  "menu.sales": "Sales",
  "menu.reports": "Reports",
  "menu.invoices": "Invoices",
  "menu.rest_order_tabs": "KDS",
  "sale.sale.all": "All",
  "sale.sale.none": "No Invoice",
  "sale.sale.awaiting payment": "Awaiting Payment",
  "sale.sale.done": "Completed",
  "account.invoice.all": "All",
  "account.invoice.draft": "Draft",
  "account.invoice.pending": "Pending",
  "account.invoice.posted": "Posted",
  "appointment_scheduling.scheduling_mode": "Care Type",
  "appointment_scheduling.room": "Rooms",
  "appointment_scheduling.calendar.room": "Rooms",
  "appointment_scheduling.edit": "Edit",
  calendar_appointment: "Calendar",
  "appointment_scheduling.reference": "Reference",
  "appointment_scheduling.ingress_service_health": "Health Service Type",
  "appointment_scheduling.description": "Description",
  "appointment_scheduling.service_order": "Service Order",
  "appointment_scheduling.msg_professional_unavailable - ": "No Availability",
  "appointment_scheduling.type_order": "Order Type",
  "party.party.type_user_health": "User Type",
  "appointment_scheduling.appointment_type": "Appointment Type",
};

export default en;
